import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { getErrorMessage } from '@frontendlib/common/utils/ErrorMessage';

@Component({
  selector: 'app-preview-error',
  templateUrl: './preview-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PreviewErrorComponent {
  public readonly error = input<unknown>();
  public readonly fallbackMessage = input<string>('Failed to load file preview');

  protected readonly message = computed<string>(() => {
    const err = this.error();
    return err == null ? this.fallbackMessage() : getErrorMessage(err);
  });
}
